import { Box, Grid, Typography, Paper, styled, TableCell, tableCellClasses, TableRow, TableContainer, Table, TableBody } from '@mui/material'
import { observer } from 'mobx-react-lite';
import { useEffectOnce } from 'usehooks-ts';
import { withNavbar } from '../../../app/layout/HOC';
import SkeltonAnimation from '../../../app/layout/SkeltonAnimation';
import { useStore } from '../../../app/stores/store';
import KoUpReCycleChart from '../charts/KoUpReCycleChart'
import KoUpReCyclePieChart from '../charts/KoUpReCyclePieChart';
import CachedIcon from '@mui/icons-material/Cached';
import ComputerIcon from '@mui/icons-material/Computer';
import ParkIcon from '@mui/icons-material/Park';
import DriveEtaIcon from '@mui/icons-material/DriveEta';
import SettingsAccessibilityIcon from '@mui/icons-material/SettingsAccessibility';
import ShowerIcon from '@mui/icons-material/Shower';
import LocalDrinkIcon from '@mui/icons-material/LocalDrink';

const StyledTableCell = styled(TableCell)(({ theme }) => ({
    [`&.${tableCellClasses.head}`]: {
        backgroundColor: '#fcfcfc',
        fontSize: 16,
        fontWeight: 300,
    },
    [`&.${tableCellClasses.body}`]: {
        fontSize: 14,
        fontWeight: 300,
        fontStrethed: 'expanded',
    },
}));
const StyledTableRow = styled(TableRow)(({ theme }) => ({

    '&:nth-of-type(odd)': {
        backgroundColor: '#DAE5F1',
    },
    '&:nth-of-type(even)': {
        backgroundColor: '#fcfcfc',
    },
    '&:last-child td, &:last-child th': {
        border: 0,
    },
}));

const ItemChart = styled(Box)(({ theme }) => ({
    backgroundColor: theme.palette.mode === "dark" ? "#1A2027" : "#fff",
    ...theme.typography.body2,
    padding: 1,
    color: theme.palette.text.secondary,
    elevation: 0,
    marginTop: 4,
    '& canvas': {
        margin: '0 auto',
        width: 300,
        // height: 400,
    }
}));


const UpcycleRecycleContainer = () => {


    const { reportingStore } = useStore();
    const { koUpReCycle, koUpReCycleLoading, loadKoUpReCycle, totalCo2 } = reportingStore;


    useEffectOnce(() => {
        loadKoUpReCycle();
    })


    return (
        <Box component='div' sx={{ mt: 25, p: 2 }}>
            {koUpReCycleLoading && <SkeltonAnimation iteration={10} />}
            {!koUpReCycleLoading && koUpReCycle &&
                <Grid container justifyContent="center">
                    <Grid container direction="column">
                        <Grid item xs={2}></Grid>
                        <Grid item xs={8}>

                            <TableContainer component={Paper}>
                                <Table aria-label="Co2 table">
                                    <TableBody>
                                        <StyledTableRow>
                                            <StyledTableCell>
                                                <Typography align='center' >Assets refurbished for reuse:</Typography>
                                            </StyledTableCell>
                                            <StyledTableCell>
                                                {koUpReCycle.upCycle}
                                            </StyledTableCell>
                                            <StyledTableCell>
                                                <ComputerIcon />
                                            </StyledTableCell>
                                        </StyledTableRow>
                                        <StyledTableRow>
                                            <StyledTableCell>
                                                <Typography align='center'>Assets refurbished for material:  </Typography>
                                            </StyledTableCell>
                                            <StyledTableCell>
                                                {koUpReCycle.reCycled}
                                            </StyledTableCell>
                                            <StyledTableCell>
                                                <CachedIcon />
                                            </StyledTableCell>
                                        </StyledTableRow>
                                        <StyledTableRow>
                                            <StyledTableCell>
                                                <Typography align='center'>Total CO2: </Typography>
                                            </StyledTableCell>
                                            <StyledTableCell>
                                                {koUpReCycle.totalCo2}
                                            </StyledTableCell>
                                            <StyledTableCell>
                                                <SettingsAccessibilityIcon />
                                            </StyledTableCell>
                                        </StyledTableRow>
                                    </TableBody>
                                </Table>
                            </TableContainer>
                        </Grid>
                        <Grid item xs={2}></Grid>
                    </Grid>
                    <Box justifyContent='center' sx={{ mt: 5 }}>
                        {!koUpReCycleLoading && koUpReCycle.reCycled < 1 &&
                            <Typography color={'red'}>Enough data for Recycled is not available to show on Chart. </Typography>
                        }
                        {!koUpReCycleLoading && koUpReCycle.upCycle < 1 &&
                            <Typography color={'red'}>Enough data for Upcycled is not available to show on Chart.</Typography>
                        }
                    </Box>
                    {!koUpReCycleLoading && koUpReCycle.reCycled > 0 && koUpReCycle.upCycle > 0 &&
                        <Grid container sx={{ mt: 5 }}>
                            <Grid item xs={2}></Grid>
                            <Grid item xs={4} direction='row' >
                                <ItemChart>
                                    <KoUpReCycleChart koUpReCycle={koUpReCycle} />
                                </ItemChart>
                            </Grid>
                            <Grid item xs={4}>
                                <ItemChart>
                                    <KoUpReCyclePieChart koUpReCycle={koUpReCycle} />
                                </ItemChart>
                            </Grid>
                            <Grid item xs={2}></Grid>
                        </Grid>
                    }
                    {totalCo2 &&
                        <Grid container direction="column" sx={{ mt: 5 }}>
                            <Grid item xs={2}></Grid>
                            <Grid item xs={8}>
                                <TableContainer component={Paper}>
                                    <Table aria-label="Co2 table">
                                        <TableBody>
                                            <StyledTableRow>
                                                <StyledTableCell colSpan={3}>
                                                    <Typography align='center' >That is equilent of:</Typography>
                                                </StyledTableCell>
                                            </StyledTableRow>
                                            <StyledTableRow>
                                                <StyledTableCell>
                                                    <Typography >Tree Seedlings grown for 10 Years</Typography>
                                                </StyledTableCell>
                                                <StyledTableCell>
                                                    {totalCo2.treeCo2}
                                                </StyledTableCell>
                                                <StyledTableCell>
                                                    <ParkIcon />
                                                </StyledTableCell>
                                            </StyledTableRow>
                                            <StyledTableRow>
                                                <StyledTableCell>
                                                    <Typography>Passenger vehicles driven for on year</Typography>
                                                </StyledTableCell>
                                                <StyledTableCell>
                                                    {totalCo2.carCo2}
                                                </StyledTableCell>
                                                <StyledTableCell>
                                                    <DriveEtaIcon />
                                                </StyledTableCell>
                                            </StyledTableRow>
                                            <StyledTableRow>
                                                <StyledTableCell>
                                                    <Typography>Liters of water</Typography>
                                                </StyledTableCell>
                                                <StyledTableCell>
                                                    {totalCo2.literOfWaterCo2}
                                                </StyledTableCell>
                                                <StyledTableCell>
                                                    <LocalDrinkIcon />
                                                </StyledTableCell>
                                            </StyledTableRow>
                                            <StyledTableRow>
                                                <StyledTableCell>
                                                    <Typography>Shower of ten minutes</Typography>
                                                </StyledTableCell>
                                                <StyledTableCell>
                                                    {totalCo2.showerCo2}
                                                </StyledTableCell>
                                                <StyledTableCell>
                                                    <ShowerIcon />
                                                </StyledTableCell>
                                            </StyledTableRow>
                                        </TableBody>
                                    </Table>
                                </TableContainer>
                            </Grid>
                            <Grid item xs={2}></Grid>
                        </Grid>
                    }
                </Grid>
            }

        </Box>
    )
}
const UpReCycleChartPage = withNavbar(observer(UpcycleRecycleContainer));
export default UpReCycleChartPage;